import React, { useRef, useEffect, useState } from 'react';
import SignaturePadLibrary from 'signature_pad';
import { Button, Typography } from 'antd';
import { SaveOutlined, UndoOutlined, DeleteOutlined } from '@ant-design/icons';
const { Title } = Typography;

const DSRSignaturePad = ({ visible, onClose, onSave, title }) => {
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);
  const [savedSignature, setSavedSignature] = useState(null);
  const [isDrawing, setIsDrawing] = useState(false);

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        initializeSignaturePad();
      }, 100);
    }
    // Cleanup
    return () => {
      if (signaturePadRef.current) {
        signaturePadRef.current.off();
        signaturePadRef.current = null;
      }
    };
    // eslint-disable-next-line
  }, [visible]);

  const initializeSignaturePad = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = 150 * ratio;
      canvas.getContext('2d').scale(1, 1);
      signaturePadRef.current = new SignaturePadLibrary(canvas, {
        backgroundColor: 'transparent',
        penColor: 'gray',
        onBegin: () => setIsDrawing(true),
        onEnd: () => setIsDrawing(false),
      });
    }
  };

  const handleSave = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const base64Image = signaturePadRef.current.toDataURL();
      setSavedSignature(base64Image);
      if (onSave) onSave(base64Image);
      onClose();
    }
  };

  const handleClear = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    setSavedSignature(null);
  };

  const handleUndo = () => {
    if (signaturePadRef.current) {
      const data = signaturePadRef.current.toData();
      if (data.length) {
        data.pop();
        signaturePadRef.current.fromData(data);
      }
    }
  };

  return (
    <div>
      <div style={{ border: '1px solid #ddd', borderRadius: 12, padding: 8, marginBottom: 12 }}>
        <canvas
          ref={canvasRef}
          style={{ width: '100%', height: 150, marginBottom: 8 }}
        />
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            icon={<UndoOutlined />}
            onClick={handleUndo}
            disabled={isDrawing}
          >
            Undo
          </Button>
          <Button
            icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
            onClick={handleClear}
            danger
          >
            Clear
          </Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
      {/* {savedSignature && (
                <div style={{ textAlign: 'center', marginTop: 12 }}>
                    <Title level={5} style={{ fontSize: 14, marginBottom: 4 }}>Signature Preview</Title>
                    <img
                        src={savedSignature}
                        alt="Signature Preview"
                        style={{ maxWidth: '100%', maxHeight: 80, border: '1px solid #eee', borderRadius: 8 }}
                    />
                </div>
            )} */}
    </div>
  );
};

export default DSRSignaturePad;
